
import { statsPrivClient } from './api';

export default class StatsService {
  /**
   * recupera os dados de correlação para uma pergunta de uma pesquisa
   */
  autoCorr(customerId, surveyId, questionId) {
    const key = `${customerId}.${surveyId}`;
    const value = localStorage.getItem(key);
    const score = parseFloat(value);
    const result = statsPrivClient.get(
      `/clientes/${customerId}/pesquisas/${surveyId}/questoes/${questionId}/correlacao/auto?score=${score}`,
    );
    return result;
  }

  /**
   * recupera os dados de correlação para uma configuração
   */
  manualCorr(customerId, surveyId, configId) {
    const result = statsPrivClient.get(
      `/clientes/${customerId}/pesquisas/${surveyId}/configuracoes/${configId}/correlacao/manual`,
    );
    return result;
  }

  /**
   * recupera os dados para simulação a partir de uma configuração inicial
   */
  simulation(customerId, surveyId, questionId) {
    const result = statsPrivClient.get(
      `/clientes/${customerId}/pesquisas/${surveyId}/questoes/${questionId}/simulacao/init?score=0.3`,
    );
    return result;
  }

  /**
   * enviar os dados para simulação a partir de uma configuração inicial
   * data = [{"chaves": ["<questionId>.<answerId>"], "percentuais": []}]
   */
  resimulation(customerId, surveyId, questionId, data) {
    const result = statsPrivClient.post(
      `/clientes/${customerId}/pesquisas/${surveyId}/questoes/${questionId}/simulacao/simulado?score=0.3`,
      data, {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    return result;
  }

  /**
   * enviar os dados para realizar cálculo de predição
   * data = [...evoultive result]
   */
  predict(customerId, surveyId, questionId, data, periods = 3) {
    const result = statsPrivClient.post(
      `/clientes/${customerId}/pesquisas/${surveyId}/questoes/${questionId}/predict/${periods}`,
      data, {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    return result;
  }
}
